'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  cta?: {
    label: string
    href: string
  }
}

export function EmptyState({ icon: Icon, title, description, cta }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 bg-gray-50 rounded-xl border border-dashed border-gray-200">
      {Icon && <Icon className="w-16 h-16 text-gray-400 mb-4" />}
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      {description && <p className="text-sm text-gray-500 text-center mb-6 max-w-md">{description}</p>}
      {cta && (
        <Button asChild className="rounded-xl bg-blue-600 hover:bg-blue-700 text-white">
          <Link href={cta.href}>{cta.label}</Link>
        </Button>
      )}
    </div>
  )
}

